/* This component serves as a filestream downloader, which contacts an API which returns stream of data and then it's set to be downloaded
and then a file-server library is used to create a file in memory and forces browser to download it via button.Click() workaround */

import saveAs from 'file-saver'
import merge from 'lodash/merge'

export function downloadFile (id, downloadApi, onProgress, onComplete, onError) {
  downloadApi(id, opt => merge({}, opt, { onDownloadProgress: onProgress, responseType: 'blob' })).then(response => {
    try {
      if (typeof onComplete === 'function') onComplete()
      let fileName = 'downloaded_file'
      let charset = 'UTF-8'
      const headers = response.headers
      const contentDisposition = headers && headers['content-disposition']
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*="?(.+)''(.+)"?/)
        if (match.length === 3) {
          fileName = decodeURIComponent(match[2])
          charset = match[1]
        }
      }
      const contentType = headers ? headers['content-type'] : 'application/octet-stream'
      const blob = new window.Blob([response.data], { type: `${contentType};charset=${charset}` })
      saveAs(blob, fileName)
    } catch (err) {
      if (typeof onError === 'function') onError(err)
      else throw err
    }
  }).catch(err => {
    if (typeof onError === 'function') onError(err)
    else throw err
  })
}



// WEBPACK FOOTER //
// ./src/utils/downloader.js